 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		18: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		18: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"1bfc9850","1":"252f366e","2":"25c1e9ddbd0f0e123887164d612266f85c641431","3":"styles","4":"e65c09e3ced7597c4e1afcd480f72716236c75f0","5":"5c8a7a775ad4b15eb47b560db96f82d3b16c4a95","6":"4e4c5919635dc4f8e955b8249f5aa4639bf81b4a","7":"62d01f0e9a1106c855f408e44249f1c1be375e0a","8":"364d1acd9bbdce5f4df719c8591d07bb218c49ba","9":"714a8bb8b84b2f226a7fe2e020e497114ce41153","10":"95b64a6e","11":"bf247cb59bd93c50b57162c973c0e115fc278762","12":"d630c711cb22a4863a333d3b3fff6770e37ef696","13":"2286dbe36d45005483297789e3de5a8b0a0fdedd","14":"5e2a4920","15":"component---src-templates-landing-page-index-jsx","16":"d38f5e342c6a1d2a84bebc0025c1f9e052fd95f0","17":"dd5195fc9cdbfe1cf940fc6a1b267e8972ed5579","21":"component---node-modules-gatsby-plugin-offline-app-shell-js","22":"component---src-pages-404-js","23":"component---src-pages-index-js","24":"component---src-templates-about-us-index-jsx","25":"component---src-templates-amc-detail-amc-details-js","26":"component---src-templates-amc-list-amc-js","27":"component---src-templates-best-mutual-funds-index-jsx","28":"component---src-templates-calculator-calculator-landing-index-js","29":"component---src-templates-calculator-index-js","30":"component---src-templates-category-category-js","31":"component---src-templates-collection-index-js","32":"component---src-templates-contact-us-index-jsx","33":"component---src-templates-disclaimer-index-jsx","34":"component---src-templates-elss-index-jsx","35":"component---src-templates-fa-qs-components-category-page-index-js","36":"component---src-templates-fa-qs-components-qa-page-index-js","37":"component---src-templates-fa-qs-index-js","38":"component---src-templates-investor-charter-index-jsx","39":"component---src-templates-loan-compare-index-js","40":"component---src-templates-mutual-fund-seo-page-index-js","41":"component---src-templates-premier-index-js","42":"component---src-templates-privacy-policy-index-jsx","43":"component---src-templates-risk-warning-index-jsx","44":"component---src-templates-sahi-hai-page-index-jsx","45":"component---src-templates-section-80-c-index-jsx","46":"component---src-templates-switch-switch-js","47":"component---src-templates-terms-of-use-index-jsx","48":"component---src-templates-top-mf-top-mf-js","49":"de71a805"}[chunkId]||chunkId) + "-" + {"0":"c2186932e24aac469fd0","1":"879c87f480e22a35d2f5","2":"39d178f5f80926ba63f1","3":"365f87b8b168dadf8c1d","4":"c6fee4918792d9bc67e7","5":"564691b9f2813a0c5356","6":"0e652d0ae39467fa56e3","7":"c372e6ce5dce23937be1","8":"2473a535c51b4f0fbb63","9":"f17a7ea1da5d8d893d0e","10":"c34db50dc5a42ae54782","11":"d4f66d53ad84236e59c8","12":"37a120ad1caaba4dd4b2","13":"f655f176f7737c125cac","14":"43f2a17fd3229b5e0b7f","15":"387064528c249c425687","16":"a85dc1d0927761385be6","17":"cccb63c7ba80acec5a09","21":"6dfd37acdc421344a628","22":"2ac9f7b7a9076ec428f7","23":"d2ef90c2a0e18395868b","24":"c49bbe35f7e364dc59d7","25":"75692d5ed0bb65a32b9b","26":"784961edb81b1485f862","27":"2311b37c5b7af0327b6f","28":"5287b291401fc2c4a3a3","29":"8bb34de7ef0488957b72","30":"28d7a655f1570b5958de","31":"5d527eefc7625b80471d","32":"e69bf7cb1411f6f83466","33":"ddb98f2b69d17191734c","34":"e4ab518c5a44de187c60","35":"8fc9b3702791c2afcb1c","36":"eff9594d6526c16a26fc","37":"d6adcb1f74e6a98d6a3f","38":"ed48e211485eecc7d50a","39":"6c99aa00bd1f58d34070","40":"500a128de76b76bceaa2","41":"dfd0b19b4b332c98a72b","42":"b440ac010412b3f77d9e","43":"5fbb63dfe1d53dfd2974","44":"f18557602d5610e77741","45":"cbc3693b63568243a667","46":"aafb9567ceff2f4df8e9","47":"2d78bac472b04ab3d736","48":"22896e846a1f103fdd79","49":"f32cc921def26d1cea70"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"1bfc9850","1":"252f366e","2":"25c1e9ddbd0f0e123887164d612266f85c641431","3":"styles","4":"e65c09e3ced7597c4e1afcd480f72716236c75f0","5":"5c8a7a775ad4b15eb47b560db96f82d3b16c4a95","6":"4e4c5919635dc4f8e955b8249f5aa4639bf81b4a","7":"62d01f0e9a1106c855f408e44249f1c1be375e0a","8":"364d1acd9bbdce5f4df719c8591d07bb218c49ba","9":"714a8bb8b84b2f226a7fe2e020e497114ce41153","10":"95b64a6e","11":"bf247cb59bd93c50b57162c973c0e115fc278762","12":"d630c711cb22a4863a333d3b3fff6770e37ef696","13":"2286dbe36d45005483297789e3de5a8b0a0fdedd","14":"5e2a4920","15":"component---src-templates-landing-page-index-jsx","16":"d38f5e342c6a1d2a84bebc0025c1f9e052fd95f0","17":"dd5195fc9cdbfe1cf940fc6a1b267e8972ed5579","21":"component---node-modules-gatsby-plugin-offline-app-shell-js","22":"component---src-pages-404-js","23":"component---src-pages-index-js","24":"component---src-templates-about-us-index-jsx","25":"component---src-templates-amc-detail-amc-details-js","26":"component---src-templates-amc-list-amc-js","27":"component---src-templates-best-mutual-funds-index-jsx","28":"component---src-templates-calculator-calculator-landing-index-js","29":"component---src-templates-calculator-index-js","30":"component---src-templates-category-category-js","31":"component---src-templates-collection-index-js","32":"component---src-templates-contact-us-index-jsx","33":"component---src-templates-disclaimer-index-jsx","34":"component---src-templates-elss-index-jsx","35":"component---src-templates-fa-qs-components-category-page-index-js","36":"component---src-templates-fa-qs-components-qa-page-index-js","37":"component---src-templates-fa-qs-index-js","38":"component---src-templates-investor-charter-index-jsx","39":"component---src-templates-loan-compare-index-js","40":"component---src-templates-mutual-fund-seo-page-index-js","41":"component---src-templates-premier-index-js","42":"component---src-templates-privacy-policy-index-jsx","43":"component---src-templates-risk-warning-index-jsx","44":"component---src-templates-sahi-hai-page-index-jsx","45":"component---src-templates-section-80-c-index-jsx","46":"component---src-templates-switch-switch-js","47":"component---src-templates-terms-of-use-index-jsx","48":"component---src-templates-top-mf-top-mf-js","49":"de71a805"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"bd45399c36ba25e93d3a","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/public/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
